import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 *
 * Loading Symbol Component
 *
 * Inputs
 *  loaderMessage: The message displayed when showing the loading symbol.
 *
 */

@Component({
    standalone: false,
    selector: 'ycn-loading-symbol',
    templateUrl: './loading-symbol.template.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSymbolComponent {
    @Input() loaderMessage!: string;
}
